import _ from 'lodash';
import React from 'react';
var Handlebars = require('../../../../../node_modules/handlebars/dist/cjs/handlebars');

const DEFAULT_PLAN_TEMPLATE = `
<div class="plan-tile_name">{{name}}</div>
<div class="plan-tile_price">
<span class="plan-tile_currency"></span>{{currency price}}
</div>
<br/>
<br/>
`;

Handlebars.registerHelper("math", function (lvalue, operator, rvalue, options) {
    lvalue = parseFloat(lvalue);
    rvalue = parseFloat(rvalue);

    return {
        "+": lvalue + rvalue,
        "-": lvalue - rvalue,
        "*": lvalue * rvalue,
        "/": lvalue / rvalue,
        "%": lvalue % rvalue
    }[operator];
});

Handlebars.registerHelper('currency', function (value) {
    return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
});

export function parsePlanOptions(websiteDescription) {
    const parsedWebsiteDescription = websiteDescription ? JSON.parse(websiteDescription) : null;
    return parsedWebsiteDescription?.template ? parsedWebsiteDescription.template : DEFAULT_PLAN_TEMPLATE;
}

function TemplateRenderer({ template, plan }) {
    let html;
    try {
        const compiledTemplate = Handlebars.compile(template);
        html = compiledTemplate({
            ...plan,
            rules: _.isString(plan.rules) ? JSON.parse(plan.rules) : {}
        });
        if (plan.details) {
            html = html.replace('plan-tile_options">', 'plan-tile_options"><div class="plan-tile_details">' + plan.details + '</div>');
        }
    } catch (e) {
        html = e;
    }

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
}

function PlanBodyFiller({ plan }) {
    return <TemplateRenderer template={parsePlanOptions(plan.websiteDescription)} plan={plan} />;
}

export default PlanBodyFiller;
